import { API } from 'aws-amplify';

const getUser = async () => {
  const user = await API.get('agentbuzz', `users`);
  return user;
};

export default getUser;



// WEBPACK FOOTER //
// ./src/services/user/getUser.js